module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_h('div', {
    staticClass: "homepage"
  }, [_h('h1', ["DÉCOUVREZ LES TÉMOIGNAGES DE COUPLES HOMOPARENTAUX"]), " ", _h('div', {
    staticClass: "couples"
  }, [_vm._l((_vm.couples), function(couple) {
    return _h('router-link', {
      staticClass: "link",
      attrs: {
        "to": '/testimonials/' + couple.slug
      }
    }, [_h('Card', {
      staticClass: "couple",
      attrs: {
        "title": couple.name,
        "subtitle": couple.location,
        "img": couple.img
      }
    })])
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34d35f4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Testimonials.vue
// module id = 51
// module chunks = 1